module.exports = __webpack_public_path__ + "img/rfid-logo.be545f38.png";